import { store } from "../store/store"
import axios from 'axios'
import { doc, getDoc, getFirestore, setDoc } from "firebase/firestore"
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth"
import { app } from "../../utils/Firebase"

const { setCurrentUser, setUsersList } = require("../reducers/users")

const dispatch = store.dispatch

const users = {
    
    logout(){
        return new Promise((resolve,reject)=>{
            signOut(getAuth(app))
            .then(result => {
                dispatch(setCurrentUser({telephone:"",prenom:"",nom:""}))
                resolve('disconnected')
            })
            .catch(err => reject(err))
        })
    },
    registerUser(data){
        return new Promise((resolve,reject)=>{
            setDoc(doc(getFirestore(),'users',data.telephone),data)
            .then(result => {
                dispatch(setCurrentUser(data))
                resolve(data)
            })
            .catch(err => reject(err))
        })
    },
    loginUser(telephone){
        return new Promise((resolve,reject)=>{
            getDoc(doc(getFirestore(),'users',telephone))
            .then(snap =>{
                let user = snap.data()
                if(user){
                    dispatch(setCurrentUser(user))
                    resolve(snap)
                }else{
                    reject('user does not exist')
                }
            })
            .catch(err => reject(err))
        })
    },
    getCurrentUser(){
        let auth = getAuth(app)
        onAuthStateChanged(auth, (user) => {
            if (user.phoneNumber) {
                getDoc(doc(getFirestore(),'users',user.phoneNumber))
                .then(snap =>{
                    let currentUser = snap.data()
                    dispatch(setCurrentUser(currentUser))
                    // this.logout()
                })
            }else{
                dispatch(setCurrentUser({telephone:"",prenom:"",nom:""}))
            }
        });
    },
    isUserNotRegistered(telephone){
        return new Promise((resolve,reject)=>{
            getDoc(doc(getFirestore(),'users',telephone))
            .then(snap => {
                let u = snap.data()
                if(u){
                    reject(snap.data())
                }else{
                    resolve('user does not regired')
                }
            })
        })
    }
}
export default users